import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { AchievementsPopupProps } from './AchievementsPopup.props';
import { Box, Typography } from '@mui/material';

import ClearIcon from '@mui/icons-material/Clear';
import AchievementsDetail from '../AchievementsDetail/AchievementsDetail';
import './AchievementsPopup.css';
const AchievementsPopup: React.FC<AchievementsPopupProps> = (props) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClose = () => {
    props.setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={props.open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          sx: {
            width: '-webkit-fill-available',
            maxWidth: '1371px',
            mt: 8,
            position: 'absolute',
            top: 0
          }
        }}>
        <>
          <div className={'achievements-popup-container'}>
            <Box width={'100%'} mb={'37px'}>
              <Box width={'100%'} display="flex" justifyContent="space-between">
                <Typography
                  sx={{ fontFamily: 'Righteous', fontSize: 24, fontWeight: 400, color: '#193051' }}>
                  {props.title}
                </Typography>
                <Typography gap={1} sx={{ display: 'flex' }}>
                  <ClearIcon
                    onClick={() => handleClose()}
                    sx={{ position: 'relative', top: '4px', cursor: 'pointer' }}
                    fontSize={'medium'}
                    htmlColor={'#193051'}
                  />
                </Typography>
              </Box>
              <Box width={'100%'} display="flex" justifyContent="space-between">
                <Typography className="achievements-popup-text">{props.subTitle}</Typography>
              </Box>
            </Box>
            <div className={'content-achievements-popup'}>
              <AchievementsDetail badgeList={props.badgeList} />
            </div>
          </div>
        </>
      </Dialog>
    </React.Fragment>
  );
};

export default AchievementsPopup;
